import PropTypes from 'prop-types'
import React, { useEffect, useState } from "react"
import { getUsers, getSubscriptions, getDashboard, addDashboardItem, createCustomer, deleteDashboardItem } from "../../store/admin/actions"
import { updateRedemption,addActivity } from "../../store/plantstore/actions"
import DataTable from 'react-data-table-component';
import Amplify, { Auth } from 'aws-amplify'
import AWS from 'aws-sdk'
import { Field, Form } from '@availity/form'
import '@availity/yup'
import * as yup from 'yup'
import { connect } from 'react-redux'
import {
  Container,
  Row,
  Col,
  Button,
  Input,
  Label,
  Card,
  CardBody,
  CardTitle,
  CardHeader,
  CardText,
  CardSubtitle,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Media,
  Table,
} from "reactstrap"
import { Link } from "react-router-dom"


const Admin = props => {

  const { onGetUsers, onAddActivity, onGetSubscriptions, onUpdateRedemption, onAddDashboardItem, onCreateCustomer, onDeleteDashboardItem, onGetDashboard, dashboard, users, subscriptions } = props
  const [modal_redeem, setModalRedeem] = useState(false)
  const [product_id, setCustomerProd] = useState()
  const [modal_activity, setModalActivity] = useState(false)
  const [modal_customer, setModalCustomer] = useState(false)
  const [activity_coins, setActivityCoins] = useState()
  const [activity_event, setActivityEvent] = useState()
  const [loading, setLoading] = useState(false);  
  const [error, setError] = useState(null); 
  const [activity_detail, setActivityDetail] = useState()
  const [selectedFile, setSelectedFile] = useState();
  const [parsedCSV, setParsedCSV] = useState(false)
  const [referrals, setReferrals] = useState([])
  const [currUser, setCurrUser] = useState()
  const [currEmail, setCurrEmail] = useState()
  const [newPassword, setNewPassword] = useState()
  const [showResetPassword, setShowResetPassword] = useState(false)
  const [redemptions, setRedemptions] = useState([])
  const [redemptionsList, setRedemptionsList] = useState([])
  const [activity, setActivity] = useState([])
  const [dashboard_type, setDashboardType] = useState("bullet")
  const [dashboard_content, setDashboardContent] = useState()
  const [dashboard_link, setDashboardLink] = useState()
  var redemptionComment = "";

 const redemption_columns = [
                {
                        name: "ID",
                        selector: row => row.redemption_id,
                        sortable: true

                },
                {
                        name: "Plant/Item",
			selector: row => row.item,
                        sortable: true

                },

                {
                        name: "Variety/Type",
			selector: row => row.option,
                        sortable: true

                },

                {
                        name: "Redemption Date",
			selector: row => row.date,
                        sortable: true

                },
                {
                        name: "Coins",
			selector: row => row.coins,
                        sortable: true
                },
                {
                        name: "Status",
                        sortable: true,
			 cell: row => (
				  <p><select defaultValue={row.status}
                                   onChange={(selectedOption) => saveRedemption(selectedOption, row)}
              >
                                   <option value="Processing">Processing</option>
                                   <option value="Submitted">Submitted</option>
                                   <option value="Shipped">Shipped</option>
                                   <option value="Completed">Completed</option>
                               </select>
                               <input type="textfield" onChange={(e)=>saveRedemptionComment(e.target.value)}/></p>

			   )
                }
         ];


 const subscription_columns = [
                {
                        name: "Customer",
      selector: row => row.customer_name,
      sortable: true
                },
                {
                        name: "Email",
      selector: row => row.email,
      sortable: true
                },
                {
                        name: "Subscription ID",
      selector: row => row.id,
      sortable: true
                },
                 {
                        name: "Product",
      selector: row => row.product_name,
      sortable: true
                },
                 {
                        name: "End Date",
      selector: row => row.expiry_date,
      sortable: true
                },

          {
                        name: "",
            sortable: true,
      cell: row => (
         <span><Button type="text" color="success" className="btn-sm" onClick={() => viewSubscription(row.id)}>Subscription Details</Button>
         <Button type="text" color="warning" className="btn-sm" onClick={() => resetPassword(row)} >Reset Password</Button></span>
                           )
                }
         ];


 const activity_columns = [
                {
                        name: "Event",
			selector: row => row.description,
                        sortable: true
                },
                {
                        name: "Detail",
			selector: row => row.target,
                        sortable: true
                },

                {
                        name: "Date",
			selector: row => row.date,
                        sortable: true
                },
                {
                        name: "Coins",
			selector: row => row.coins,
                        sortable: true
                },
         ];

  const resetPassword = (user) => {
      setCurrUser(user.customer_name)
      setCurrEmail(user.email)
      setShowResetPassword(true)
  }

  const handleResetPassword = async () => {
    setLoading(true);  // Set loading state to true
    setError(null);  // Clear any previous errors
    try {
      const currentCredentials = await Auth.currentCredentials();

      // Initialize the AWS SDK with the user's credentials
      const cognito = new AWS.CognitoIdentityServiceProvider({
        credentials: Auth.essentialCredentials(currentCredentials),
        region: 'us-east-1', // Ensure this is set in your config
      });

      const params = {
         UserPoolId: 'us-east-1_o2d7FPiLR',  
         Username: currUser,  // The username input
         Password: newPassword,  // The new password input
         Permanent: true,  // Set the new password as permanent
       };
 
        const response = await cognito.adminSetUserPassword(params).promise();
    console.log('Password reset response:', response);  // Log the response
    alert('Password has been successfully reset.');
          setShowResetPassword(false)
       } catch (error) {
          console.error('Error resetting password:', error);  // Log error
          setError('Failed to reset password. Please try again.');  // Set error state
       } finally {
          setLoading(false);  // Set loading state to false
       }
      
         
  };


  function changeActivityEvent (value) {
     setActivityEvent(value)
  }

  function changeActivityDetail (value) {
     setActivityDetail(value)
  }

  function  changeActivityCoins (value) {
     setActivityCoins(value)
  }

  function changeDashboardType (value) {
     setDashboardType (value)
  }

  function changeDashboardContent (value) {
     setDashboardContent (value)
  }

  function changeDashboardLink (value) {
     setDashboardLink (value)
  }

  function deleteDashboardItem (id) {
     onDeleteDashboardItem(id)
  }

  function addDashboardItem () {
     var newId = 1;
     for (var i=0; i<dashboard.length; i++) {
	 if (dashboard[i].id>newId) 
	     newId = dashboard[i].id;
     }
     console.log("new id is " + newId);
     newId++;
     var item = {
        id: newId.toString(),
	type: dashboard_type,
	content: dashboard_content,
	link: dashboard_link
     }
     onAddDashboardItem(item)
  }	

  const chooseFile = (event) => {
      setSelectedFile(event.target.files[0]);
  };

  const tog_redeem = () => {
      setModalRedeem(!modal_redeem)
  }

    const tog_customer = () => {
      setModalCustomer(!modal_customer)
  }

  const tog_activity = () => {
      setModalActivity(!modal_activity)
  }

  const addActivity = () => {
      var newActivity = {
         email: currUser.email,
	 description: activity_event,
	 target: activity_detail,
	 coins: activity_coins,
	 date: new Date().toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"})
      }
      console.log(newActivity)
      onAddActivity(newActivity);
      tog_activity();
  }

  const saveRedemptionComment = (comment) => {
     redemptionComment = comment
  }

  const saveRedemption = (selectedOption, row)  => {
     console.log(redemptionComment)
     var iRedemptions = redemptions;
     row.status = selectedOption.target.value
     for (var i=0; i<iRedemptions.length; i++) {
       	 if (row.redemption_id==iRedemptions[i].redemption_id) {
	     iRedemptions[i] = row;
	     setRedemptions(iRedemptions);
	     row.username = currUser.username
	     row.comment = redemptionComment
	     onUpdateRedemption(row)
	     tog_redeem()
         }
     }
  }

  function viewSubscription (subscriptionId) {
      const url = `https://dashboard.stripe.com/subscriptions/${subscriptionId}`;
      window.open(url, '_blank', 'noopener,noreferrer');
  }

  function showRedemptions (username) {
      for (var i=0; i<users.length; i++) {
	   var user = users[i]
	   if (user.username == username) {
	      setCurrUser(user)
	      setRedemptions(user.redemptions)
	      tog_redeem()
	      break;
            }
      }
  }

  function showActivity (username) {
     for (var i=0; i<users.length; i++) {
           var user = users[i]
           if (user.username == username) {
              setCurrUser(user)
              setActivity(user.activity)
              tog_activity()
              break;
            }
      }
  }

  function submitStripeCustomer() {
      currUser.product_id = product_id
      onCreateCustomer(currUser)
      setModalCustomer(false)
  }

   function createStripeKickstarter (username) {
     for (var i=0; i<users.length; i++) {
           var user = users[i]
           if (user.username == username) {
              setCurrUser(user)
               setModalCustomer(true)
              break;
            }
      }
  }

  useEffect(() => {
    const { onGetUsers } = props
    onGetUsers()
    onGetDashboard()
    onGetSubscriptions()
  }, [])

  useEffect (() => {
     if (users) {
	 var redemptions = [];
         for (var i=0; i<users.length; i++) {
              if (users[i].redemptions && users[i].redemptions.length>0) {
		  for (var j=0; j<users[i].redemptions.length; j++) {
		      var redemption = { ...users[i].redemptions[j]}
		      redemption["username"] = users[i].username;
                      redemptions.push(redemption);
		  }
              }
         }
	 setRedemptionsList(redemptions)
     }

  }, [users])

  const user_columns2 = [
                {
                        name: "Email",
			selector: row => row.email,
			sortable: true
                },
          {
                        name: "User",
                        selector: row => row.username,
		        sortable: true,
			cell: row => (
				 <span>{row.username} <Button type="text" color="success" className="btn-sm" onClick={() => showRedemptions(row.username)} >Redemptions</Button>  <Button type="text" color="info" onClick={() => showActivity(row.username)} className="btn-sm"  >Activity</Button><Button type="text" color="info" onClick={() => createStripeKickstarter(row.username)} className="btn-sm"  >Create Kickstarter</Button></span>
                           )
                },

  ];


  const user_columns = [
                {
                        dataField: "email",
                        text: "Email",
			sort: true
                },
	  {
                        dataField: "username",
                        text: "User",
		        sort: true,
                        formatter: (value, row) => (
                                <span>{value} <Button type="text" color="success" className="btn-sm" onClick={() => showRedemptions(value)} >Redemptions</Button>  <Button type="text" color="info" onClick={() => showActivity(value)} className="btn-sm"  >Activity</Button><Button type="text" color="info" onClick={() => createStripeKickstarter(row.username)} className="btn-sm"  >Create Kickstarter</Button></span>
  ),
                },

  ];
	      


  const csvFileToArray = string => {
    const csvHeader = string.slice(0, string.indexOf("\n")).split(",");
    const csvRows = string.slice(string.indexOf("\n") + 1).split("\n");

    const array = csvRows.map(i => {
      const values = i.split(",");
      const obj = csvHeader.reduce((object, header, index) => {
        object[header] = values[index];
        return object;
      }, {});
      return obj;
    });
    setParsedCSV (true)
 
    var accum = {};
    array.forEach((element) => {
         if (element.referrer_email!="" && element.referrer_email!=undefined) {
	    if (accum[element.referrer_email]) {
		accum[element.referrer_email].number++;                
                accum[element.referrer_email].emails.push (element.email);
	    } else {
		accum[element.referrer_email] = {}
	        accum[element.referrer_email].number = 1;
                accum[element.referrer_email].emails = [];
                accum[element.referrer_email].emails.push (element.email);
	    }
         }   
    });
    setReferrals(accum);
    return array;

  };

  const processCSV = () => {
      console.log(selectedFile);

       if (selectedFile) {
            const fileReader = new FileReader();

            fileReader.onload = function (event) {
                const csvOutput = event.target.result;
		console.log(csvFileToArray(csvOutput));
            };

            fileReader.readAsText(selectedFile);
        }
  };

 const saveReferralStats = () => {
  };

console.log("SADFAS")
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Row>

	    <Col md={12}>
 <Row>
              <Card>
	   <CardHeader  style={{backgroundColor:'#AEBFFF'}}>
                  <h5>
			    Subscriptions List
                  </h5>
                </CardHeader>

                 <CardBody>
                   <DataTable
                       columns={subscription_columns}
                       data={subscriptions}
                       pagination />
                 </CardBody>
              </Card>

          </Row>
   <Row>
                  <Col md="12">
             <Card outline className="border">
                <CardHeader  style={{backgroundColor:'#AEBFFF'}}>
                  <h5>
                    Users 
                  </h5>
                </CardHeader>
                <CardBody>
                   <DataTable
                       columns={user_columns2}
                       data={users}
                       pagination />
                </CardBody>
              </Card>

            </Col>
          </Row>

	    </Col>

	  </Row>


    <Modal
        size="lg"
	isOpen={modal_redeem}
        toggle={() => {
                 tog_redeem()
              }}
    >

          <Card>
	      <DataTable
                       columns={redemption_columns}
                       data={redemptions}
                       pagination />

          </Card>
    </Modal>

<Modal
        size="lg"
        isOpen={modal_customer}
        toggle={() => {
                 tog_customer()
              }}
    >

          <Card>
      <Row>
                 <Col>Select the Customer Subscription For {currUser?.username}</Col>
                 <Col><p><select onChange={(event) => setCustomerProd(event.target.value)}
              >
                                   <option value="price_1Q1CwYDHlUD75tspiZgGj8Ut">Kickstarter Lifetime</option>
                                   <option value="price_1PudgzDHlUD75tspjgvI9t1f">Kickstarter 1-year</option>
                                   <option value="price_1Q1BXMDHlUD75tspFeMUi7Ma">SAGE Monthly</option>
                                   <option value="price_1Q1BWDDHlUD75tspX88AcIat">SAGE Yearly</option>
                                   <option value="price_1PuefYDHlUD75tspPQjLioev">SAGE Trial</option>
                                   <option value="price_1Pue8oDHlUD75tspE7uVbBl0">SAGE Comp</option>
                               </select></p></Col>
            </Row>
      <Row>
           <Col md="12"><br/><center><Button type="text" color="success" className="btn-sm" onClick={() => submitStripeCustomer()} >Create New Customer in Stripe</Button> </center>
           </Col>
      </Row>

          </Card>
    </Modal>


 <Modal
        size="lg"
        isOpen={modal_activity}
        toggle={() => {
                 tog_activity()
              }}
    >

          <Card>
	  <Row>
	    <Col md="12">
	          <DataTable
                       columns={activity_columns}
                       data={activity}
                       pagination />
	     </Col> 
	  </Row>
	    <Row>
	        <Col md="6">
	            <h4>Add a new event for the user:</h4>
	        </Col>
	    </Row>
	    <Row>
	         
	         <Col>General Description: </Col>
	         <Col>Specific Item: </Col>
	         <Col>Coins To Add: </Col>
	    </Row>
	    <Row>
                 <Col><input type="text" value={activity_event} onChange={e => (changeActivityEvent(e.target.value))}/></Col>
                 <Col><input type="text" value={activity_detail} onChange={e => (changeActivityDetail(e.target.value))}/></Col>
                 <Col><input type="text" value={activity_coins} onChange={e => (changeActivityCoins(e.target.value))}/></Col>
            </Row>
	    <Row>
	         <Col md="12"><br/><center><Button type="text" color="success" className="btn-sm" onClick={() => addActivity()} >Add Activity</Button> </center>
	         </Col>
	    </Row>

          </Card>
    </Modal>


<Modal isOpen={showResetPassword} toggle={() => {

 }}
>
    <ModalHeader tag="h4">
        Change User Password
    </ModalHeader>
    <ModalBody>

 <Form
                      className="form-horizontal"
                      onSubmit={handleResetPassword}
                      initialValues={{
                           newPassword: ''
                      }}
                      validationSchema={yup.object().shape({
                           newPassword: yup
                            .string()
                            .isRequired(true, 'New Password is required')
                      })}
                    >
                    <Row>
                       <Col md={3}>
                          <h6>Username:</h6>
                       </Col>
                       <Col md={3}>
                          <h5><b>{currUser}</b></h5>
                       </Col>
                    </Row>
                    <Row>
                       <Col md={3}>
                          <h6>Email:</h6>
                       </Col>
                       <Col md={3}>
                          <h5><b>{currEmail}</b></h5>
                       </Col>
                    </Row>
                      <div className="form-group">
                        <Field
                          name="newPassword"
                          label="New Password"
                          className="form-control"
                          type="password"
                          onChange={e => setNewPassword(e.target.value)}
                        />
                      </div>

                      <Row className="form-group">
                        <Col className="text-right">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                          >
                            Change Password
                          </button>
                        </Col>
                      </Row>
                    </Form>
    </ModalBody>
</Modal>



        </Container>
      </div>
    </React.Fragment>
  )
}

Admin.propTypes = {
  users: PropTypes.array,
  onGetUsers: PropTypes.func,
}

const mapStateToProps = ({ admin }) => {
  var redemptions = [];
  var subs = [...admin.subscriptions]
  if (subs && subs.length>0) {
      for (var i=0; i<subs.length; i++) {
	  console.log(subs[i].customer)
	  console.log("AAAA")
	         for (var j=0; j<admin.users.length; j++) {
	              if (admin.users[j].customer_id==subs[i].customer) {
		                 subs[i].customer_name = admin.users[j].username
                     subs[i].email = admin.users[j].email
		          break;
	       }
	  }
     }
  }

 return({
  users: admin.users,
  subscriptions: subs,
  dashboard: admin.dashboard})
}

const mapDispatchToProps = dispatch => ({
  onGetUsers: () => dispatch(getUsers()),
  onUpdateRedemption: (redemption) => dispatch(updateRedemption(redemption)),
  onAddActivity: (activity) =>dispatch(addActivity(activity)),
  onGetSubscriptions: () => dispatch (getSubscriptions()),
  onGetDashboard: () => dispatch(getDashboard()),
  onAddDashboardItem: (item) => dispatch(addDashboardItem(item)),
  onDeleteDashboardItem: (id) => dispatch(deleteDashboardItem(id)),
  onCreateCustomer: (profile) => dispatch(createCustomer(profile)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Admin)
